export default function BaseErrorBoundaryHandler() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      Sorry we couldn&apos;t display the page you requested. Please try again later.
    </div>
  );
}
